export class User {
    userID?: number;
    userFirstName?: string;
    userLastName?: string;
    userEmail?: string;
    lastActive?: Date;
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date;
    updatedBy?: string;
    status?: string;
    approvedOrRejectedBy?: string;
    approvedOrRejectedOn?: Date;

    UserFullName?:string;
    
}
